import { memo, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper";
import { useSelector } from "react-redux";
import { ReactComponent as RightArrow } from "../../../../assets/Icons/rightArrow.svg";
import { ReactComponent as LeftArrow } from "../../../../assets/Icons/leftArrowIcon.svg";
import Translate from "../../../Multilanguage/Translate";
import { toast } from "react-toastify";
const modules = [Autoplay, Navigation];

function generateUUID() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

const SectionSlider = memo(
  ({
    children,
    title,
    list,
    slidesPerView,
    loop = false,
    spaceBetween = 0,
    className = "",
    link,
    data,
    visibleItemsCount,
    notViewAll = false,
    episode = false,
    episodeTitle,
    styleElement = true,
    margin = false,
    thumbnail,
    isRegisterPage = false,
    hideMobileNavigation = false,
  }) => {
    const themeSchemeDirection = '';
    const slider = useRef(null);
    const navUUID = useRef(`nav-${generateUUID()}`);
    const projectInfo = useSelector((state) => state?.projectInfo?.value);
    const template = projectInfo?.projectConfig?.config?.TEMPLATE;
    const pubid = projectInfo?.projectConfig?.pubid;
    const isKids = template === 'TEMPLATE_12';
    const hideNavigationOnMobile = hideMobileNavigation && template !== "TEMPLATE_10";
    const navigationClassName = hideNavigationOnMobile ? " mobile-navigation-hidden" : "";

    const handleHeadingClick = (e) => {
      const userId = localStorage.getItem('userId');
      if (template === 'TEMPLATE_12' && !userId && isRegisterPage) {
        e.preventDefault();
        toast.info(<Translate textKey={'sign_in_required'} />);
        window.dispatchEvent(new Event('kids-register-focus-email'));
      }
    };

    let portraitThumbnail;
    if (thumbnail === "PORTRAIT") {
      portraitThumbnail = true;
    }
    const initSwiper = (swiper) => {
      addCustomClassToVisibleSlides(swiper);
    };

    const addCustomClassToVisibleSlides = (swiper) => {
      if (slider.current) {
        if (swiper) {
          slider.current
            .querySelectorAll(".swiper-slide")
            .forEach((separateSlide) => separateSlide.classList.remove("last"));

          const swiperSlide = slider.current.querySelectorAll(
            ".swiper-slide-visible"
          );

          const lastVisibleSlide = swiperSlide[swiperSlide.length - 1];

          setTimeout(() => {
            if (lastVisibleSlide) {
              lastVisibleSlide.classList.add("swiper-active", "last");
            }
          }, 0);
        }
      }
    };

    const enableCustomRowCount = true;
    const computedRowCount = (enableCustomRowCount && visibleItemsCount) ? Math.ceil(Number(visibleItemsCount)) : projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT;

    return (
      <div className={className}>
        <div className={ template === "TEMPLATE_10" ? 'gaiaSectionSlider' : (template === 'TEMPLATE_12' ? 'sectioncontainer kids' : 'sectioncontainer')}>
          <div className="wrapper">
            <div className={"overflow-hidden card-style-slider" + (margin ? " margincontainer" : "")} ref={slider}>
              <div className="d-flex align-items-center justify-content-between px-3 my-4">
              {data?.show_all_needed === true ? (
                <Link
                  to={`/category/${data?.key}?career=${data?.key}`}
                  state={{ "type": data?.type }}
                  className="text-decoration-none"
                  style={{ position: "relative", zIndex: 9 }}
                  onClick={handleHeadingClick}
                >
                  <div className="heading-container">
                    <h4 className="topHeading">

                      {title}
                      {(template != 'TEMPLATE_9' && template != 'TEMPLATE_12' && title) && <span><RightArrow /></span>}
                    </h4>
                    {((template == 'TEMPLATE_9' || template == 'TEMPLATE_12') && title) && <span className="show-all"><Translate textKey={"show_all"}/></span>}
                  </div>
                </Link>
              ) : (
                <div className="heading-container">
                  <h4 className="topHeading">{title}</h4>
                </div>
              )}
              </div>
              <div className={isKids ? 'kids-swiper-nav-wrapper' : ''}>
              <Swiper
                key={themeSchemeDirection}
                dir={themeSchemeDirection}
                className={thumbnail === "PORTRAIT" ? "portrait" : "landscape"}
                slidesPerView={slidesPerView}
                loop={loop}
                watchSlidesProgress
                spaceBetween={spaceBetween}
                navigation={isKids ? {
                  prevEl: `#${navUUID.current}-prev`,
                  nextEl: `#${navUUID.current}-next`,
                } : {
                  prevEl: ".swiper-button-prev",
                  nextEl: ".swiper-button-next",
                }}
                breakpoints={{
                  0: styleElement || portraitThumbnail ? {
                    slidesPerView: 2,
                    spaceBetween: 0,
                  } : {
                    slidesPerView: isRegisterPage ? 2 : 1,
                    spaceBetween: 0,
                  },
                  425: styleElement || portraitThumbnail ? {
                    slidesPerView: 3,
                    spaceBetween: 0,
                  } : {
                    slidesPerView: isRegisterPage ? 2 : 1,
                    spaceBetween: 0,
                  },
                  576: styleElement || portraitThumbnail ? {
                    slidesPerView: 4,
                    spaceBetween: 0,
                  } : {
                    slidesPerView: 2,
                    spaceBetween: 0,
                  },
                  640: styleElement || portraitThumbnail ? {
                    slidesPerView: 3,
                    spaceBetween: 0,
                  } : {
                    slidesPerView: 2,
                    spaceBetween: 0,
                  },
                  768: styleElement || portraitThumbnail ? {
                    slidesPerView: 5,
                    spaceBetween: 0,
                  } : {
                    slidesPerView: 2,
                    spaceBetween: 0,
                  },
                  980: styleElement || portraitThumbnail ? {
                    slidesPerView: 5,
                    spaceBetween: 0,
                  } : {
                    slidesPerView: 4,
                    spaceBetween: 0,
                  },
                  1025: styleElement || portraitThumbnail ? {
                    slidesPerView: computedRowCount ? computedRowCount : (portraitThumbnail ? 7 : 4),
                    spaceBetween: 0,
                  } : {
                    slidesPerView: 4,
                    spaceBetween: 0,
                  },
                  1500: styleElement || portraitThumbnail ? {
                    slidesPerView: computedRowCount ? computedRowCount : (portraitThumbnail ? 7 : 4),
                    spaceBetween: 0,
                  } : {
                    slidesPerView: 4,
                    spaceBetween: 0,
                  },
                }}
                onSwiper={initSwiper}
                onSlideChange={initSwiper}
                modules={modules}
              >
                {list.map((data, index) => (
                  <SwiperSlide tag="li" key={data?.video_id || data?.show_id || data?.vanity_url || index}>
                    {children(data, index)}
                  </SwiperSlide>
                ))}
                {!isKids && (
                  <>
                    <div className={`swiper-button-next${navigationClassName}`}>
                      {/* <RightArrow /> */}
                    </div>
                    <div className={`swiper-button-prev${navigationClassName}`}>
                      {/* <LeftArrow /> */}
                    </div>
                  </>
                )}
              </Swiper>
              {isKids && (
                <>
                  <div id={`${navUUID.current}-next`} className={`swiper-button-next${navigationClassName}`} />
                  <div id={`${navUUID.current}-prev`} className={`swiper-button-prev${navigationClassName}`} />
                </>)
              }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
);

SectionSlider.displayName = "SectionSlider";

export default SectionSlider;
